<template>
    <div>
        <v-dialog v-model="dialog" max-width="700">
            <v-card class="rounded-lg d-flex flex-column" style="height: 100%;">
                <!-- Header -->
                <v-card-title class="d-flex justify-space-between align-center" style="background-color: #536091; color: white;">
                    <div>
                    <span class="font-weight-bold text-h6" style="font-family: Saira Condensed, sans-serif;">{{ main_title }}</span>
                    <div class="text-caption" style="font-family: Saira Condensed, sans-serif;">{{ sub_title }}</div>
                    </div>
                    <v-btn flat icon color="primary" @click="closeDialog" :disabled="loading">
                    <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
        
                <!-- Divider -->
                <v-divider></v-divider>
        
                <!-- Body -->
                <v-card-text class="px-6 py-4" style="max-height: 60vh; overflow-y: auto;">
                    <v-form ref="form">
                        <v-row dense>
                            <v-col
                                v-for="(slot, index) in slots"
                                :key="index"
                                cols="12"
                            >
                            <div
                                class="pa-4 mb-4 rounded-lg"
                                :style="{
                                    backgroundColor: slot.status === 'done' ? '#e6ffed' : '#f7fafc',
                                    border: '1px solid',
                                    borderColor: slot.status === 'done' ? '#38a169' : '#e2e8f0',
                                }"
                            >
                                <div class="d-flex justify-space-between align-center mb-2">
                                    <span class="text-subtitle-2 font-weight-medium" style="color: #2d3748;">
                                        {{ slot.slotTitle }}
                                    </span>
                                    <span
                                        class="text-caption font-weight-medium"
                                        :style="{ color: getStatusColor(slot.status) }"
                                    >
                                        {{ slot.status.toUpperCase() }}
                                    </span>
                                </div>
            
                                <v-text-field
                                    v-model="slot.bonusBuyPayout"
                                    type="number"
                                    variant="outlined"
                                    density="compact"
                                    hide-details
                                    :rules="[v => (v !== '' && v >= 0) || 'Value cannot be negative']"
                                    :label="$t('Fields_Label.Guess_The_Balance.Prize')"
                                    class="mt-1"
                                    style="background: white;"
                                />
            
                                <!-- <v-btn
                                    v-if="gtbStatus != 'done'"
                                    color="primary"
                                    class="mt-3"
                                    size="small"
                                    variant="flat"
                                    :loading="slot.loading"
                                    @click="saveSingleSlot(index)"
                                >
                                {{ $t('Buttons.Save') }}
                                </v-btn> -->
                            </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
        
                <!-- Footer -->
                <v-divider></v-divider>
                <v-card-actions class="px-6 py-4">
                    <v-spacer />
                    <v-btn variant="text" color="grey" @click="closeDialog" :disabled="loading">{{ $t('Buttons.Cancel') }}</v-btn>
                    <!-- <v-btn variant="flat" color="primary" class="elevation-0" :loading="loading" disabled @click="saveSlots">Save All</v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" :timeout="2500" :color="snackColor" location="top">
            <v-icon>mdi-alert-circle</v-icon>
            <span class="ml-2" style="font-family: Saira Condensed, sans-serif;">{{ snackText }}</span>
        </v-snackbar>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
    name: "SlotDialog",
        data() {
            return {
                main_title: this.$t('DialogTitle.Slot_Details.Header'),
                sub_title: this.$t('DialogTitle.Slot_Details.Sub_Title'),

                dialog: false,

                snackbar: false,
                snackText: "",
                snackColor: "",
                loading: false,
                slots: [],
                gtbStatus: 'active',
            };
        },
        methods: {
            init(data) {
                this.openDialog();
                this.gtbStatus = data.status;
                this.slots = data.slots.map(slot => ({
                    ...slot,
                    loading: false,
                }));

            },
            openDialog() {
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
            showSnackbar(message, color = 'success') {
                this.snackText = message;
                this.snackColor = color;
                this.snackbar = true;
            },
            getStatusColor(status) {
                switch (status) {
                    case 'done':
                        return '#38a169'; // green
                    case 'error':
                        return '#e53e3e'; // red
                    default:
                        return '#718096'; // gray
                }
            },
            async saveSingleSlot(index) {
                const slot = this.slots?.[index];

                if (!slot) {
                    console.warn(`No slot found at index ${index}`);
                    return;
                }

                if (slot.bonusBuyPayout === null || isNaN(slot.bonusBuyPayout)) {
                    this.showSnackbar(`Invalid payout value for "${slot.slotTitle}"`, 'error');
                    return;
                }

                slot.loading = true;

                const token = localStorage.getItem('maherco-admin-accesstoken'); 
                if (!token) {
                    this.showSnackbar('Authentication token missing.', 'error');
                    slot.status = 'error';
                    slot.loading = false;
                    return;
                }

                const formData = {
                    slotName: slot.slotTitle,
                    payout: Number(slot.bonusBuyPayout)
                };

                try {
                    await axios.patch(
                    `${process.env.VUE_APP_SERVER_URL}/api/admin/guess-the-balance/slot/payout`,
                    formData,
                    {
                        headers: {
                        Authorization: `Bearer ${token}`,
                        'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                        },
                    }
                    );

                    slot.status = 'done';
                    this.showSnackbar(`Saved "${slot.slotTitle}" successfully.`);
                } catch (error) {
                    slot.status = 'error';

                    if (error.response) {
                    console.error('API Error:', error.response.data);
                    } else {
                    console.error('Request Error:', error.message);
                    }

                    this.showSnackbar(`Failed to save "${slot.slotTitle}"`, 'error');
                } finally {
                    slot.loading = false;
                }
            },
            async saveSlots() {
                this.loading = true;
        
                try {
                    await Promise.all(this.slots.map((slot, index) => this.saveSingleSlot(index)));
                    this.showSnackbar("All slots saved successfully.");
                    this.closeDialog();
                } catch {
                    this.showSnackbar("Some slots failed to save.", "error");
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>